<template>
    <div>
        <template>
            <h5 class="my-4">{{ $t('managerForm.settingAdvanced.sendingInformation') }}</h5>
            <div class="ml-3">
                <!-- 送信設定 -->
                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 190px">{{ $t('managerForm.settingAdvanced.settingSending') }}</label>
                    <div class="col-sm-9">
                        <div class="d-flex flex-wrap" style="gap: 12px">
                            <div v-for="(item, idx) in OPTION_SEND_EMAIL" :key="idx">
                                <InputRadio
                                    class="mr-4"
                                    :model.sync="initForm.option_send_email"
                                    :name="`admin-option-send-email-${idx}`"
                                    :id="`admin-option-send-email-${idx}`"
                                    :value="item.id"
                                    :label="item.label"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-if="!optionSend3">
            <h5 class="pt-3 mb-4" style="border-top: 1px solid #ccc">
                {{ $t('managerForm.settingAdvanced.basicEmailSettings') }}
            </h5>
            <template>
                <div class="ml-3">
                    <!-- 差出人アドレス -->
                    <div class="form-group row">
                        <label class="col-sm-1 text-nowrap" style="min-width: 190px"
                            >{{ $t('managerForm.settingAdvanced.fromAddress') }}
                            <span v-if="onHandleCheckFieldRequired(configData.configFieldFromAddress.typesValidate)" class="text-danger"
                                >*</span
                            ></label
                        >
                        <div class="col-sm-9">
                            <Multiselect
                                :id="`fromAddress`"
                                :value.sync="initForm.from_address"
                                :options="listEmailFromAddress"
                                :config="configData.configFieldFromAddress"
                            />
                        </div>
                    </div>
                    <!-- 宛先アドレス -->
                    <div v-if="optionSend1" class="form-group row">
                        <label class="col-sm-1 text-nowrap" style="min-width: 190px"
                            >{{ $t('managerForm.settingAdvanced.toAddress') }}
                            <span v-if="onHandleCheckFieldRequired(configData.configFieldToAddress.typesValidate)" class="text-danger">*</span></label
                        >
                        <div class="col-sm-9">
                            <InputText
                                :id="`toAddress`"
                                :model.sync="initForm.to_address"
                                :config.sync="configData.configFieldToAddress"
                                @blur="handleValidateField(configData.configFieldToAddress, 'more-mail')"
                            />
                            <span class="inputSupportInfo">{{ $t('managerForm.settingAdvanced.noteBlockConditionMail') }}</span>
                        </div>
                    </div>
                    <!-- BCCアドレス  -->
                    <div v-if="optionSend1" class="form-group row">
                        <label class="col-sm-1 text-nowrap" style="min-width: 190px"
                            >{{ $t('managerForm.settingAdvanced.bcc') }}
                            <span v-if="onHandleCheckFieldRequired(configData.configFieldBccAddress.typesValidate)" class="text-danger"
                                >*</span
                            ></label
                        >
                        <div class="col-sm-9">
                            <InputText
                                :id="`bccAddress`"
                                :model.sync="initForm.bcc_address"
                                :config.sync="configData.configFieldBccAddress"
                                @blur="handleValidateField(configData.configFieldBccAddress, 'more-mail')"
                            />
                            <span class="inputSupportInfo">{{ $t('managerForm.settingAdvanced.noteBlockConditionMail') }}</span>
                        </div>
                    </div>
                    <!-- ユーザー返信時アドレス -->
                    <div class="form-group row">
                        <label class="col-sm-1 text-nowrap" style="min-width: 190px">{{ $t('managerForm.settingAdvanced.replyAddress') }} </label>
                        <div class="col-sm-9">
                            <div class="row">
                                <div class="col-sm-5">
                                    <Multiselect
                                        :id="`replyAddress`"
                                        :value.sync="initForm.choice_reply_address"
                                        :options="OPTION_REPLY_ADDRESS"
                                        :config="{ trackBy: 'id', label: 'label', error: false, isRemove: true }"
                                        @select="handleChoiceReplyAddress"
                                    />
                                </div>
                                <div class="col-sm-4">
                                    <Multiselect
                                        :id="`replyAddress-1`"
                                        :value.sync="initForm.email_reply_address"
                                        :options="listEmailReplyAddress"
                                        :disabled="initForm.choice_reply_address.id !== 'default'"
                                        :config="configData.configFieldReplyAddress"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- 件名 -->
                    <div v-if="optionSend1" class="form-group row">
                        <label class="col-sm-1 text-nowrap" style="min-width: 190px"
                            >{{ $t('managerForm.settingAdvanced.subject') }}
                            <span v-if="onHandleCheckFieldRequired(configData.configFieldSubject.typesValidate)" class="text-danger">*</span></label
                        >
                        <div class="col-sm-9">
                            <InputText
                                :id="`Subject`"
                                :model.sync="initForm.subject"
                                :config.sync="configData.configFieldSubject"
                                @blur="handleValidateField(configData.configFieldSubject)"
                            />
                        </div>
                    </div>
                    <!-- 本文 -->
                    <div v-if="optionSend1" class="form-group row">
                        <label class="col-sm-1 text-nowrap" style="min-width: 190px"
                            >{{ $t('managerForm.settingAdvanced.mainText') }}
                            <span v-if="onHandleCheckFieldRequired(configData.configFieldMainText.typesValidate)" class="text-danger">*</span></label
                        >
                        <div class="col-sm-9">
                            <div class="position-relative">
                                <div class="pl-0 col-sm-4">
                                    <Multiselect
                                        :id="`blockChoiceSendingMail`"
                                        :value="blockChoiceSendingMail"
                                        :options="listOriginBlock"
                                        :config="configData.configFieldSelectChoiceSendingMail"
                                        @select="onHandleSetBlockChoiceSendingMail"
                                    />
                                </div>
                                <div class="w-100">
                                    <Editor
                                        ref="TextareaComponent"
                                        :id="`mainText-admin-${initForm.option_send_email}`"
                                        :key="`mainText-admin-${initForm.option_send_email}`"
                                        :model.sync="initForm.main_text"
                                        :configInit="editorConfigWithoutVideo"
                                        :configError.sync="configData.configFieldMainText"
                                        @blur="handleValidateField(configData.configFieldMainText)"
                                    />
                                    <div v-if="configData.configFieldMainText.error" class="d-block invalid-feedback mt-1">
                                        <span>
                                            {{ configData.configFieldMainText.errorCustomMess }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- 個人情報項目のマスク表示 -->
                    <div class="form-group row pt-3">
                        <label class="col-sm-1 text-nowrap" style="min-width: 190px"
                            >{{ $t('managerForm.settingAdvanced.maskingPersonalInformation') }}
                            <span v-if="onHandleCheckFieldRequired(['required'])" class="text-danger">*</span></label
                        >
                        <div class="col-sm-9">
                            <div class="d-flex flex-wrap" style="gap: 12px">
                                <div v-for="(item, idx) in OPTION_MASK" :key="idx">
                                    <InputRadio
                                        class="mr-4"
                                        :model.sync="initForm.masking_personal_information_fields"
                                        :name="`admin-mask-${idx}`"
                                        :id="`admin-mask-${idx}`"
                                        :value="item.id"
                                        :label="item.label"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <template v-if="optionSend2">
                    <h5 class="pt-3 mb-4" style="border-top: 1px solid #ccc">
                        {{ $t('managerForm.settingAdvanced.settingConditions') }}
                    </h5>
                    <div class="ml-3">
                        <!-- メール送信条件 -->
                        <div class="form-group row">
                            <label class="col-sm-1 text-nowrap" style="min-width: 190px"
                                >{{ $t('managerForm.settingAdvanced.conditionSendEmail') }}
                                <span
                                    v-if="onHandleCheckFieldRequired(configData.configFieldSelectMailSendingConditions.typesValidate)"
                                    class="text-danger"
                                    >*</span
                                ></label
                            >
                            <div class="col-sm-9">
                                <div class="row">
                                    <div class="col-sm-5">
                                        <Multiselect
                                            :id="`conditionSendEmail`"
                                            :value.sync="initForm.block_id"
                                            :options="blockList"
                                            :config.sync="configData.configFieldSelectMailSendingConditions"
                                            @select="handleSelectBlock"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
                <BlockSending
                    v-if="initForm.block_id && optionSend2"
                    style="border-top: 1px solid #ccc"
                    ref="blockSending"
                    :opTabpanel.sync="initForm.email_settings_for_each_option"
                    :configData="configConditionSendBlock"
                    :listOriginBlock="listOriginBlock"
                />
            </template>
        </template>
    </div>
</template>

<script>
import {
    OPTION_SEND_EMAIL,
    OPTION_REPLY_ADDRESS,
    OPTION_MAIL_I,
    OPTION_MASK,
    OPTION_NOT_SELECTED,
    initSettingEmailOption,
    selectDefaultSendmail
} from '../../constants';
import { onHandleMoreMail, onHandleFilterOptionSendEmail, onHandleEditorConfigWithoutVideo } from '../../handlers';
import { InputRadio, InputText } from '@/components/Input';
import { validateField } from '@/utils/validate';
import { onHandleCheckFieldRequired } from '@/utils/handlers';
import { VALUE_ETC } from '../../../../../iframe-page/handlers';
import { ALL_BLOCK_TYPE } from '@/config/constants';

import Multiselect from '@/components/Multiselect/main.vue';
import Editor from '@/components/Editor/main.vue';
import BlockSending from './block-sending.vue';
export default {
    name: 'AlertAdmin',
    components: { InputRadio, InputText, Multiselect, Editor, BlockSending },
    props: {
        formData: {
            type: Object,
            required: true,
            default: () => {}
        },
        configData: {
            type: Object,
            required: true,
            default: () => {}
        },
        listBlock: {
            type: Array,
            required: true,
            default: () => []
        },
        listMail: {
            type: Array,
            required: true,
            default: () => []
        },
        listEmailReplyAddress: {
            type: Array,
            required: true,
            default: () => []
        },
        listEmailFromAddress: {
            type: Array,
            required: true,
            default: () => []
        },
        listOriginBlock: {
            type: Array,
            required: true,
            default: () => []
        }
    },
    data() {
        return {
            OPTION_REPLY_ADDRESS,
            OPTION_MASK,
            VALUE_ETC,
            OPTION_NOT_SELECTED,
            initForm: this.formData,
            configForm: this.configData,
            blockList: this.listBlock,
            configConditionSendBlock: [],
            OPTION_SEND_EMAIL: OPTION_SEND_EMAIL(),
            blockChoiceSendingMail: selectDefaultSendmail(),
            editorConfigWithoutVideo: onHandleEditorConfigWithoutVideo()
        };
    },
    computed: {
        optionSend1() {
            return this.initForm.option_send_email === OPTION_SEND_EMAIL()[0].id;
        },
        optionSend2() {
            return this.initForm.option_send_email === OPTION_SEND_EMAIL()[1].id;
        },
        optionSend3() {
            return this.initForm.option_send_email === OPTION_SEND_EMAIL()[2].id;
        }
    },
    methods: {
        onHandleCheckFieldRequired,
        handleChoiceReplyAddress(value) {
            if (value.id !== 'default') {
                this.initForm.email_reply_address = '';
            }
        },
        handleValidateField(configField, action = null) {
            validateField(configField);
            switch (action) {
                case 'more-mail':
                    onHandleMoreMail(configField, 'one');
                    break;
            }
        },

        handleSelectBlock(block) {
            let blockType = block.block_type;
            let optionBlock = block.options;
            let optionsValue = [];
            switch (blockType) {
                case ALL_BLOCK_TYPE.BLOCK_RADIO:
                    if (block.extension.setting_others.other_use) {
                        optionsValue = [
                            ...optionBlock,
                            {
                                id: VALUE_ETC,
                                is_custom_value: true,
                                value: block.extension.setting_others.label_other
                            },
                            ...OPTION_NOT_SELECTED
                        ];
                    } else {
                        optionsValue = [...optionBlock, ...OPTION_NOT_SELECTED];
                    }
                    break;
                default:
                    optionsValue = [...optionBlock, ...OPTION_NOT_SELECTED];
                    break;
            }

            const optionList = optionsValue.map((itOp) => {
                return {
                    ...initSettingEmailOption(),
                    value: itOp.value,
                    option_id: itOp.id,
                    is_not_selected: itOp?.is_not_selected ?? false,
                    is_custom_value: itOp?.is_custom_value ?? false
                };
            });
            this.initForm.email_settings_for_each_option = optionList;
            this.configConditionSendBlock = optionList.map(() => initSettingEmailOption().configEachField());
            if (this.$refs?.blockSending) {
                this.$refs.blockSending.onSetActiveBlockTab();
            }
        },

        onHandleSetBlockChoiceSendingMail(evt) {
            const editor = this.$refs.TextareaComponent.editorInstance;
            if (!editor) return;
            editor.insertContent(`<<${evt.label}>>`);
            this.blockChoiceSendingMail = selectDefaultSendmail();
        }
    },
    watch: {
        formData: {
            handler(val) {
                this.initForm = val;
                this.configConditionSendBlock = val?.email_settings_for_each_option?.map((item) =>
                    initSettingEmailOption(item).configEachField(item)
                );
            },
            immediate: true,
            deep: true
        },

        configData: {
            handler(val) {
                this.configForm = val;
            },
            immediate: true,
            deep: true
        },

        listBlock: {
            handler(val) {
                this.blockList = val;
                this.OPTION_SEND_EMAIL = onHandleFilterOptionSendEmail(val, OPTION_SEND_EMAIL());
            },
            immediate: true,
            deep: true
        },

        listMail: {
            handler(val) {
                let newMailTypeOtherI = val.filter((item) => item.id !== OPTION_MAIL_I.id);
                this.OPTION_REPLY_ADDRESS = [...OPTION_REPLY_ADDRESS, ...newMailTypeOtherI];
            },
            immediate: true,
            deep: true
        },

        initForm: {
            handler(val) {
                this.$emit('update:formData', val);
            },
            immediate: true,
            deep: true
        }
    }
};
</script>

<style lang="scss" scoped></style>
